// utils/cookies.ts
export const setCookie = (name: string, value: string, days: number = 365): void => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
};

export const getCookie = (name: string): string => {
  return document.cookie.split('; ').reduce((r: string, v: string) => {
    const parts = v.split('=');
    return parts[0] === name ? decodeURIComponent(parts[1]) : r;
  }, '');
};

export const getOrCreateUserId = (): string => {
  let userId = getCookie('respell_user_id');
  if (!userId) {
    userId = `user_${Date.now()}_${Math.random().toString(36).substr(2, 5)}`;
    setCookie('respell_user_id', userId);
  }
  return userId;
};